import { useMemo } from 'react';

import { randomUUID } from '@betterment/core';

export const useFallbackKeys = <T>(items: T[]): { item: T; key: string }[] => {
  return useMemo(() => items.map(item => ({ item, key: randomUUID() })), [items]);
};
